<template>
  <AwButton :to="previousRoute" :icon="buttonIcon" size="sm" color="secondary" :variant="props.variant ?? 'ghost'" />
</template>

<script setup lang="ts">
import { AwButton } from "@asap/design";

const props = defineProps<{ fallbackRoute: string; icon?: string; variant?: "ghost" | "outline" }>();

const route = useRoute();

const previousRoute = computed(() => (route.query.from as string) ?? props.fallbackRoute);

const buttonIcon = computed(() => props.icon ?? "i-ph-caret-left");
</script>
